@if (links() && links().length) {
  <div class="link-container">
    <h4 class="title">{{ title() | translate }}</h4>
    @for (link of links(); track link) {
      @if (isQuickLinks()) {
        <a [href]="link.url | addFr : link.type === E_LINK_TYPE.External" class="link" target="_blank">
          <div class="link--title">{{ link.shortTitle || link.title }}</div>
          @if (isDateShown()) {
            @if (useStartDate() && link.startDate) {
              <div class="date">{{ HELPER.formatDateWithLocalizedMonth(link.startDate) }}</div>
            } @else {
              <div class="date">{{ HELPER.formatDateWithLocalizedMonth(link.publishDate) }}</div>
            }
          }
        </a>
      } @else {
        <a [href]="link.sourceUrl | addFr" class="link">
          <div class="link--title">{{ link.shortTitle || link.title }}</div>
          @if (isDateShown()) {
            @if (useStartDate() && link.startDate) {
              <div class="date">{{ HELPER.formatDateWithLocalizedMonth(link.startDate) }}</div>
            } @else {
              <div class="date">{{ HELPER.formatDateWithLocalizedMonth(link.publishDate) }}
              </div>
            }
          }
        </a>
      }
    }


    <app-see-all
      [relatedId]="relatedId()"
      [contentType]="contentType()"
      [showSeeAllButton]="!!relatedId() && !!contentType()">
    </app-see-all>
  </div>
}
